import React from "react";
import './ReferalPage.css';
import { NavLink } from "react-router-dom"
import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import IndexMain03 from "../../../img/IndexMain/IndexMain03.svg";
import IndexMain04 from "../../../img/IndexMain/IndexMain04.svg";
import IndexMain05 from "../../../img/IndexMain/IndexMain05.svg";
import ReferalPage01 from "../../../img/ReferalPage/ReferalPage01.svg";
import ReferalPage02 from "../../../img/ReferalPage/ReferalPage02.svg";
import ReferalPage03 from "../../../img/ReferalPage/ReferalPage03.svg";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import IndexMain from "../IndexMain/IndexMain";
import { referalLang } from "./referalLang";

class ReferalPage extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            Unites : 4,
            Balance:  this.props.session.Balance,
            Language: localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        }}

    render(){
        return (
            <div className="ReferalPage ">
                <TopPafeInfo session={this.props.session} />

                <div className="ReferalPageTop ">                    
                    <div className="ReferalPageTopLink"><NavLink to='/referalstatistic' activeClassName="ReferalPageTopActiveLink">{referalLang.statistic[this.state.Language]}</NavLink></div>
                    <div className="ReferalPageTopLink"><NavLink to='/myguest' activeClassName="ReferalPageTopActiveLink">{referalLang.guest[this.state.Language]}</NavLink></div>
                    {/*<div className="ReferalPageTopLink activeTab"><NavLink to='/referal' activeClassName="ReferalPageTopActiveLink">REFERRAL PROGRAM</NavLink></div>*/}
                </div>
                <div className="ReferalPageMain StandartPartMain">
                    <div className="ReferalPageMainIn ">
                        <div className="ReferalPageMainInStructure">
                            <div className="ReferalPageMainInStructureTitle">Structure</div>
                            <div className="ReferalPageMainInStructureText">Referral Program consist from a few steps, how you can get Bonus Account and take part in Exodus programm</div>
                            <div className="ReferalPageMainInStructureSchema">
                                <div className="ReferalPageMainInStructureSchemaElement01">You get 1 Bonus Account for each Rating Bonus you’ll got from referral friend</div>
                                <div className="ReferalPageMainInStructureSchemaElement02">On 550 days, 80% of the subscription amount is proportionally credited to the Exodus Account.</div>
                                <div className="ReferalPageMainInStructureSchemaElement03">
                                    <img src={IndexMain05}/>
                                    <div className="ReferalPageMainInStructureSchemaElement03Text">Rating <br />Bonus</div>
                                </div>
                                <div className="ReferalPageMainInStructureSchemaElement04">
                                    <div className="ReferalPageMainInStructureSchemaElement04Top">550 Days</div>
                                    <div className="ReferalPageMainInStructureSchemaElement04Line"><img src={ReferalPage03}/></div>
                                    <div className="ReferalPageMainInStructureSchemaElement04Bottom">80% Exodus Account</div>
                                </div>
                                <div className="ReferalPageMainInStructureSchemaElement05">
                                    <img src={IndexMain03}/>
                                    <div className="ReferalPageMainInStructureSchemaElement05Text">Exodus <br />Account</div>
                                </div>
                                <div className="ReferalPageMainInStructureSchemaElement06">
                                    <div className="ReferalPageMainInStructureSchemaElement06Top">550 Days</div>
                                    <div className="ReferalPageMainInStructureSchemaElement06Line"><img src={ReferalPage02}/></div>
                                    <div className="ReferalPageMainInStructureSchemaElement06Bottom">20% UniQs Cash Account</div>
                                </div>
                                <div className="ReferalPageMainInStructureSchemaElement07">On 550 days, 20% of the subscription amount will be credited pro data to the UniQs Cash Account.</div>
                                <div className="ReferalPageMainInStructureSchemaElement08">
                                    <img src={IndexMain04}/>
                                    <div className="ReferalPageMainInStructureSchemaElement08Text">UniQs Cash <br />Wallet</div>
                                </div>
                                {/*<div className="ReferalPageMainInStructureSchemaElement09">During 210 days 20% converts to Economic Unites</div>*/}
                            </div>
                        </div>
                        <div className="ReferalPageMainInStructure ReferalPageMainInStructurePhone">
                            <div className="ReferalPageMainInStructureTitle">Structure</div>
                            <div className="ReferalPageMainInStructureText">Referral Program consist from a few steps, how you can get Bonitet Unites and take part in Exodus programm</div>
                            <div className="ReferalPageMainInStructureSchema">
                                <div className="ReferalPageMainInStructureSchemaElement01">You get 1 Bonitet Uniten for each Economic Uniten you’ll got from referral friend</div>
                                <div className="ReferalPageMainInStructureSchemaElement03">
                                    <img src={IndexMain04}/>
                                    <div className="ReferalPageMainInStructureSchemaElement03Text">Bonitet <br/>Unites</div>
                                </div>
                                <div className="ReferalPageMainInStructureSchemaElement06">
                                    <div className="ReferalPageMainInStructureSchemaElement06Top">365 Bank Days</div>
                                    <div className="ReferalPageMainInStructureSchemaElement06Line"><img src={ReferalPage02}/></div>
                                    <div className="ReferalPageMainInStructureSchemaElement06Bottom">80% Exodus Unites</div>
                                </div>
                                <div className="ReferalPageMainInStructureSchemaElement08">
                                    <img src={IndexMain04}/>
                                    <div className="ReferalPageMainInStructureSchemaElement08Text">Exodus <br/>Unites</div>
                                </div>
                                <div className="ReferalPageMainInStructureSchemaElement09">During 210 days 80% converts to Exodus Unites</div>
                            </div>
                        </div>
                    <div className="ReferalPageMainInRewards">
                            <div className="ReferalPageMainInStructureTitle">Rewards</div>
                            <div className="ReferalPageMainInStructureText">Rewards from “Referral Programm” depend from your Rank and deposited on your “Value Balance”</div>
                            <table>
                                <thead>
                                <tr>
                                    <th>Rank</th>
                                    <th>Rank Cost</th>
                                    <th>Referral line*</th>
                                    <th>Reward</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>Basic Member</td>
                                    <td>787 <img className="refImg" src={IndexMain04} width="20px" height="20px" /></td>
                                    <td>1</td>
                                    <td>50 <img className="refImg" src={IndexMain04} width="20px" height="20px" /></td>
                                </tr>
                                {/*<tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>Investor</td>
                                    <td>5.000 €</td>
                                    <td>2</td>
                                    <td>30 €</td>
                                </tr>
                                <tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>VIP Investor</td>
                                    <td>50.000 € </td>
                                    <td>3</td>
                                    <td>20 €</td>
                                </tr>
                                <tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>Union Investor</td>
                                    <td>100.000 € </td>
                                    <td>4</td>
                                    <td>10 €</td>
                                </tr>
                                <tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>Industrie Investor</td>
                                    <td>500.000 € </td>
                                    <td>5</td>
                                    <td>5 €</td>
                                </tr>*/}
                                </tbody>
                            </table>
                            {/*<table>
                                <thead>
                                <tr>
                                    <th>Rank</th>
                                    <th>Rank Cost</th>
                                    <th>Referal line*</th>
                                    <th>Reward</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>Trader</td>
                                    <td>250 €</td>
                                    <td>1</td>
                                    <td>50 €</td>
                                </tr>
                                <tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>Home Trader </td>
                                    <td>2.500 € </td>
                                    <td>2</td>
                                    <td>80 €</td>
                                </tr>
                                <tr>
                                    <td className="ReferalPageMainInRewardsOneTD"><img src={ReferalPage01}/>Union Trader</td>
                                    <td>25.000 € </td>
                                    <td>3</td>
                                    <td>100 €</td>
                                </tr>
                                </tbody>
                            </table>
                        <div className="ReferalPageMainInStructureBottom"><img src={ReferalPage01}/>*You can get reward only from 1 line if you become “Investor”, and each new rank add more “Referal lines”, from which you can get reward by once time. Traders algo get % awards from each new referal trader from theirs turover”</div>
                        */}        
                    </div>
                </div>
                </div>
            </div>
        )}}

export default withAuth(session => session && session)(withRouter(ReferalPage));